import { Roles } from "../../config/Roles";
import { deriveBuyerEligibility } from "../../utils/marketplaceBuyerEligibility";
import useAppContext from "./useAppContext";
import useAuthorization from "./useAuthorization";
import useSession from "./useSession";

/**
 * Client-side eligibility for **entering** the marketplace (dashboard links, navigation guards).
 * Uses {@link deriveBuyerEligibility} only — race window, purchase access, registration state.
 *
 * Does **not** load `/market/myPurchases` or apply the PAYING buyer lock; that applies only when
 * starting a new purchase (marketplace offer cards via {@link deriveAuthenticatedBuyerEligibility}).
 *
 * @param {Object} race - Race document
 * @param {Object|null} [registration] - User's registration for this race, if any
 * @returns {{ disabled: boolean, reason?: string }}
 */
function useMarketplaceBuyerEligibility(race, registration = null) {
  const { session } = useSession();
  const isAuthenticated = session?.authenticated === true;
  const { authorized: isAdmin } = useAuthorization([Roles.admin]);
  const { authorized: isAuthority } = useAuthorization([Roles.authority]);
  const { data: appContextPayload } = useAppContext();
  const masterStatus = appContextPayload?.masterStatus;

  if (!isAuthenticated) {
    return { disabled: true, reason: "Pro koupi je nutné se přihlásit." };
  }

  return deriveBuyerEligibility(race, registration, { isAdmin, isAuthority }, masterStatus);
}

export default useMarketplaceBuyerEligibility;
